(() => {
  const sectionSelector = '[data-ods-product-tabs-section]';
  const triggerSelector = '[data-ods-specifications-trigger]';
  const contentSelector = '[data-ods-specifications-content]';

  const buildSpecificationsTable = (content) => {
    if (content.dataset.odsSpecificationsProcessed === 'true') return;

    const list = content.querySelector('ul, ol');
    if (!list) return;

    const items = Array.from(list.children).filter((item) => item.tagName === 'LI');
    if (items.length < 2) return;

    const rows = [];

    for (const item of items) {
      const text = item.textContent.trim();
      const colonIndex = text.indexOf(':');

      if (colonIndex <= 0) return;

      const label = text.slice(0, colonIndex).trim();
      const value = text.slice(colonIndex + 1).trim();

      if (!label || !value) return;

      rows.push({ label, value });
    }

    if (rows.length < 2) return;

    const tableWrap = document.createElement('div');
    const table = document.createElement('table');
    const tbody = document.createElement('tbody');

    tableWrap.className = 'ods-specifications-table-wrap';
    table.className = 'ods-specifications-table';

    rows.forEach((row) => {
      const tr = document.createElement('tr');
      const th = document.createElement('th');
      const td = document.createElement('td');

      th.scope = 'row';
      th.textContent = row.label;
      td.textContent = row.value;

      tr.appendChild(th);
      tr.appendChild(td);
      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    tableWrap.appendChild(table);
    list.replaceWith(tableWrap);
    content.dataset.odsSpecificationsProcessed = 'true';
  };

  const processSection = (section) => {
    section.querySelectorAll(contentSelector).forEach(buildSpecificationsTable);
  };

  if (window.ODSProductSpecificationsLoaded) {
    return;
  }

  window.ODSProductSpecificationsLoaded = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest(triggerSelector);
    if (!trigger) return;

    const section = trigger.closest(sectionSelector);
    if (!section) return;

    requestAnimationFrame(() => {
      const details = trigger.closest('details');
      if (details && !details.open) return;

      processSection(section);
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target;
    if (!(root instanceof Element)) return;

    const sections = root.matches(sectionSelector)
      ? [root]
      : Array.from(root.querySelectorAll(sectionSelector));

    sections.forEach((section) => {
      section.querySelectorAll(triggerSelector).forEach((trigger) => {
        const details = trigger.closest('details');
        const isOpenAccordion = details && details.open;
        const isSelectedTab = !details && trigger.getAttribute('aria-current') === 'true';

        if (isOpenAccordion || isSelectedTab) {
          processSection(section);
        }
      });
    });
  });
})();
